module.exports = __webpack_public_path__ + "static/media/Media.cfe16577.svg";